import React from 'react'
import { createListCollection } from '@chakra-ui/react';
import { Controller } from "react-hook-form";
import { Field } from "../../ui/field";
import { SelectContent, SelectItem, SelectRoot, SelectTrigger, SelectValueText } from "../../ui/select"
import { useColorModeValue } from '../../ui/color-mode';
import { darkMode, lightMode } from '../../../theme/config';

const SelectBox = (props) => {
    const {label, invalid, errorText, control, name="selectBox", placeholder="Select option", items=[], multiple = false, clearable = false, disabled = false, rules, value, onChange, size } = props;
    const itemsList = createListCollection({items});
    const backgroundColor = useColorModeValue(lightMode.boxBackgroundColor, darkMode.boxBackgroundColor);
    
    // If control is provided and valid, use Controller
    if (control) {
      return (
        <Field label={label} invalid={invalid} errorText={errorText}>
            <Controller
              control={control}
              name={name}
              rules={rules}
              render={({ field }) => {
              const selectComponent = (
                <SelectRoot
                  name={field.name}
                  value={field.value}
                  onValueChange={({ value }) => field.onChange(value)}
                  onInteractOutside={() => field.onBlur()}
                  collection={itemsList}
                  multiple={multiple}
                  disabled={disabled}
                  bg={backgroundColor}
                  size={size}
                >
                  <SelectTrigger clearable={clearable} disabled={disabled}>
                    <SelectValueText placeholder={placeholder} />
                  </SelectTrigger>
                  <SelectContent maxHeight="220px" style={{ zIndex: 10000}}>
                    {itemsList.items.map((item) => (
                      <SelectItem item={item} key={item.value}>
                        {item.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </SelectRoot>
              );

              return selectComponent;
            }}
          />
        </Field>
      );
    }
    
    // If no control, use regular SelectRoot with value/onChange
    return (
      <Field label={label} invalid={invalid} errorText={errorText}>
        <SelectRoot
          value={value}
          onValueChange={({ value }) => onChange && onChange({ target: { value } })}
          collection={itemsList}
          multiple={multiple}
          disabled={disabled}
          bg={backgroundColor}
          size={size}
        >
          <SelectTrigger clearable={clearable} disabled={disabled}>
            <SelectValueText placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent maxHeight="220px" style={{ zIndex: 10000}}>
            {itemsList.items.map((item) => (
              <SelectItem item={item} key={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </SelectContent>
        </SelectRoot>
      </Field>
    );
}

// const itemsList = createListCollection({
//     items: [
//       { label: "React.js", value: "react" },
//       { label: "Vue.js", value: "vue" },
//       { label: "Angular", value: "angular" },
//       { label: "Svelte", value: "svelte" },
//     ],
//   })

export default SelectBox
